import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { User } from '../../model/user.model';
import GenericInfo, { InfoField } from '../adminScreen/GenericInfo';
import Swal from 'sweetalert2';
import { UpdateUserAPI, deleteUser } from "../../api/user.api";
import { setAllUsers, updateUser } from "../../Redux/User/userAction";
// import {UserType} from "../../model/userType.model"
interface UserInfoViewProps {
  selectedUser: User;
  refresh: () => void;
  onClose?: () => void;
}
interface UserType {
  id: string;
  description: string;
}

const allUserTypes: UserType[] = [
  { id: '1', description: 'מנהל' },
  { id: '2', description: 'עובד' },
  // ...שאר הסוגים
];

const UserInfoView: React.FC<UserInfoViewProps> = ({ selectedUser, refresh, onClose }) => {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const users = useSelector((state: { user: { allUser: User[] } }) => state.user.allUser);

  useEffect(() => {
    setCurrentUser(selectedUser);
  }, [selectedUser]);

  const handleFieldsUpdate = (updatedFields: InfoField[]) => {
    if (!currentUser) return;

    const updatedUser = { ...currentUser };
    updatedFields.forEach(field => {
      if (field.fieldName) {
        updatedUser[field.fieldName] = field.value;
      }
    });

    setCurrentUser(updatedUser);
  };

  const onSubmit = async (updatedData: Partial<User>) => {
    if (!currentUser) return;
    try {
      onClose && onClose();
     const fullUserType: UserType = (() => {
      if (!updatedData.userType) return currentUser.userType;
    
      if (typeof updatedData.userType === 'object' && 'description' in updatedData.userType) {
        return updatedData.userType as UserType;
      }
        const id =
        typeof updatedData.userType === 'string'
          ? updatedData.userType
          : (updatedData.userType as { id: string }).id;
    
      const found = allUserTypes.find(ut => ut.id === id);
      return found ?? currentUser.userType;
    })();
    

    const updatedUser: User = {
      ...currentUser,
      ...updatedData,
      userType: fullUserType,
      workLog: updatedData.workLog ?? currentUser.workLog ?? [],
      projectsId: updatedData.projectsId ?? currentUser.projectsId ?? {},
    };
    


      const result = await UpdateUserAPI(updatedUser);

      setCurrentUser(result.data);
      dispatch(updateUser(result.data));

      Swal.fire({
        title: 'הצלחה!',
        text: 'המשתמש עודכן בהצלחה',
        icon: 'success',
        confirmButtonText: 'אישור',
      });
      refresh();

      const updatedUsers = users.map(user =>
        user.id === result.data.id ? result.data : user
      );
      dispatch(setAllUsers(updatedUsers));
    } catch (err) {
      console.error('Error updating user:', err);
    }
  };

  const handleDeleteUser = async () => {
    
 onClose && onClose();
    const result = await Swal.fire({
      title: 'האם אתה בטוח?',
      text: 'לא תוכל לשחזר את המשתמש לאחר המחיקה!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'מחק',
      cancelButtonText: 'ביטול',
    });

    if (result.isConfirmed && currentUser) {
      try {
        if (!users) {
          console.error("❌ רשימת המשתמשים (users) לא הוגדרה!");
          Swal.fire('שגיאה', 'לא ניתן לטעון את רשימת המשתמשים למחיקה', 'error');
          return;
        }
    
        onClose && onClose();
    
        console.log("🟡 מנסה למחוק את המשתמש עם id:", currentUser.id);
        await deleteUser(currentUser.id);
    
        Swal.fire('נמחק!', 'המשתמש נמחק בהצלחה', 'success');
    
        const updatedUsers = users.filter(user => user.id !== currentUser.id);
        dispatch(setAllUsers(updatedUsers));
        refresh();
    
      } catch (error: any) {
        console.error('❌ שגיאה במחיקת משתמש:', error.response?.data || error.message || error);
        Swal.fire('שגיאה', error.response?.data?.message || 'אירעה שגיאה בעת המחיקה', 'error');
      }
    }
    
      
  };

  if (!currentUser) return null;

  const fields: InfoField[] = [
    { label: 'שם פרטי', fieldName: 'firstName', value: currentUser.firstName, editType: 'text' },
    { label: 'שם משפחה', fieldName: 'lastName', value: currentUser.lastName, editType: 'text' },
    { label: 'אימייל', fieldName: 'email', value: currentUser.email, editType: 'text' },
    { label: 'סיסמה', fieldName: 'password', value: currentUser.password, editType: 'text' },
    { label: 'סוג משתמש', fieldName: 'userType', value: currentUser.userType.description, editType: 'text' },
    { label: 'מזהה משתמש', fieldName: 'userType', value: currentUser.userType.id, editType: 'text' },



  ];

  return (
    <div style={{ width: '100%' }}>
      <GenericInfo
        title={`${currentUser.firstName} ${currentUser.lastName}`}
        fields={fields}
        onSubmit={onSubmit}
        onFieldsUpdate={handleFieldsUpdate}
        onDelete={handleDeleteUser}
      />
    </div>
  );
};

export default UserInfoView;
